import type { ReactNode } from 'react';
import { Option } from '#components/form-elements/options/option';

export interface MultiSelectOptionType {
  key: string;
  value: string;
  icon?: string;
  recommended?: boolean;
  disabled?: boolean;
}

export interface MultiSelectOptionProps<T extends MultiSelectOptionType> {
  item: T;
  onToggle?: (itemKey: string) => void;
  renderOption?: (item: T) => ReactNode;
  className?: string;
}

export function MultiSelectOption<T extends MultiSelectOptionType>({
  item,
  renderOption,
  className,
}: MultiSelectOptionProps<T>): ReactNode {
  const recommendedSuffix = item.recommended ? '-recommended' : '';
  const testId = `multi-select-option-${item.key}${recommendedSuffix}`;

  return (
    <Option
      className={className}
      data-testid={testId}
      id={item.key}
      isDisabled={item.disabled}
      key={item.key}
      textValue={item.value}
    >
      {renderOption ? renderOption(item) : <span>{item.value}</span>}
    </Option>
  );
}
